import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';

import Plans from './plans';
import PrimaryPlan from './primary_plan';

export default function UserRow({ user }) {
  return (
    <tr class="align-middle">
      <td className={classNames({ 'text-muted': user.disabled })}>
        {`${user.name} ${user.disabled ? '(Disabled)' : ''}`}
      </td>
      <td><Plans user={user} /></td>
      <td><PrimaryPlan user={user} /></td>
    </tr>
  );
}

UserRow.propTypes = {
  user: PropTypes.shape({
    disabled: PropTypes.bool,
    name: PropTypes.string.isRequired,
  }).isRequired,
};
